'use client';

import { getIsMobile } from '@/libs/utils/user';
import * as S from './styles';

interface ContactFinalProps {
  onOpenContact?: (isMobile: boolean) => void;
}

const ContactFinal = ({ onOpenContact }: ContactFinalProps) => {
  const baseImageUrl = process.env.NEXT_PUBLIC_BASE_IMAGE_URL;
  const isMobile = getIsMobile();

  if (isMobile) return null;
  return (
    <S.Container>
      <S.Inner>
        <S.CommunityImage src={`${baseImageUrl}/landing/enterprise/cta-community-pc-v1.png`} alt={'리뷰매니저'} width={464} height={243} />
        <S.Text>
          모든 리뷰 데이터를 한곳에서
          <br />
          리뷰 관리의 운영 부담은 줄이고 매출을 높여요
        </S.Text>
        <S.BtnContact onClick={() => onOpenContact?.(false)}>엔터프라이즈 상담 신청</S.BtnContact>
      </S.Inner>
    </S.Container>
  );
};

export default ContactFinal;
